import React from 'react';

/**
 * Kleiner Badge der Firmen/Kontakte mit is_test_data=true markiert.
 * Default: inline neben display_name. Größe: small/medium.
 */
export function TestBadge({ show, size = 'small', title }: {
  show?: boolean;
  size?: 'small' | 'medium';
  title?: string;
}) {
  if (!show) return null;
  const padding = size === 'small' ? '1px 6px' : '2px 8px';
  const fontSize = size === 'small' ? '9px' : '11px';
  return (
    <span
      title={title ?? 'Testdatensatz — nicht produktiv verwenden'}
      style={{
        display: 'inline-block',
        padding,
        borderRadius: '10px',
        fontSize,
        fontWeight: 700,
        letterSpacing: '0.5px',
        textTransform: 'uppercase',
        background: '#fff3cd',
        color: '#856404',
        border: '1px solid #ffe69c',
        verticalAlign: 'middle',
        lineHeight: 1,
      }}
    >
      Test
    </span>
  );
}
